import { Roles } from 'src/shared/enums';
import { RoleGuard } from '../shared/auth/guards/role.guard';
import { AuthGuard } from '../shared/auth/guards/auth.guard';

export const flashAuditsPaths = {
	default: '',
	root: 'flash-audits',
	list: 'list',
};

export const flashAuditsFragments = {
	default: [flashAuditsPaths.default],
	root: [flashAuditsPaths.default, flashAuditsPaths.root],
	list: [
		flashAuditsPaths.default,
		flashAuditsPaths.root,
		flashAuditsPaths.list,
	],
};

export const flashAuditsDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const flashAuditsDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: {
		roles: flashAuditsDefaultAuthRoles,
	},
};
